import React from 'react';
import Icon from '../../../components/AppIcon';

const ProjectCard = ({ project, onViewDetails }) => {
  return (
    <div className="bg-white rounded-lg enterprise-shadow enterprise-border overflow-hidden enterprise-transition enterprise-hover group">
      <div className="p-6 pb-4">
        {/* Header */}
        <div className="flex items-start justify-between mb-3">
          <div className="flex items-center space-x-3">
            <div className="w-12 h-12 rounded-lg flex items-center justify-center bg-surface">
              <Icon name={project?.icon || 'Layers'} size={22} className="text-primary" />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-slate-900">{project?.title}</h3>
              <div className="flex items-center space-x-2 text-sm text-slate-600">
                <Icon name="Clock" size={16} />
                <span>Duration: {project?.duration}</span>
              </div>
            </div>
          </div>
          {project?.category && (
            <span className="px-3 py-1 rounded-full text-xs font-medium bg-primary/10 text-primary">
              {project?.category}
            </span>
          )}
        </div>

        {/* Summary */}
        {project?.summary && (
          <p className="text-slate-700 text-sm leading-relaxed mb-4">
            {project?.summary}
          </p>
        )}

        {/* What we did */}
        {project?.whatWeDid && (
          <div className="mb-4">
            <h4 className="text-sm font-medium text-slate-900 mb-2">What we did</h4>
            <p className="text-slate-700 text-sm leading-relaxed">
              {project?.whatWeDid}
            </p>
          </div>
        )}

        {/* Tags */}
        {project?.tags?.length > 0 && (
          <div className="flex flex-wrap gap-2 mb-4">
            {project?.tags?.slice(0, 6)?.map((tag, index) => (
              <span key={index} className="px-2 py-1 bg-surface text-text-secondary text-xs rounded-md">
                {tag}
              </span>
            ))}
            {project?.tags?.length > 6 && (
              <span className="px-2 py-1 bg-surface text-text-secondary text-xs rounded-md">
                +{project?.tags?.length - 6} more
              </span>
            )}
          </div>
        )}

        {/* Stack */}
        {project?.stack?.length > 0 && (
          <div className="flex flex-wrap gap-2 mb-4">
            {project?.stack?.slice(0, 5)?.map((tech, index) => (
              <span key={index} className="px-2 py-1 bg-primary/5 text-primary text-xs rounded-md">
                {tech}
              </span>
            ))}
            {project?.stack?.length > 5 && (
              <span className="px-2 py-1 bg-primary/5 text-primary text-xs rounded-md">
                +{project?.stack?.length - 5} more
              </span>
            )}
          </div>
        )}

        {/* Feedback */}
        {project?.feedback && (
          <div className="bg-success/10 border border-success/20 rounded-lg p-3 mb-4">
            <div className="flex items-start space-x-2">
              <Icon name="MessageSquare" size={16} className="text-success mt-0.5" />
              <span className="text-sm text-slate-700 italic">
                "{project?.feedback}"
              </span>
            </div>
          </div>
        )}

        {/* Actions removed per request */}
      </div>
    </div>
  );
};

export default ProjectCard;


